/**
 * @fileoverview Logging constants
 * @module constants
 */

/**
 * Log level definitions
 * @constant {Object}
 */
export const LOG_LEVEL = Object.freeze({
  TRACE: 'TRACE',
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARNING',
  ERROR: 'ERROR',
  CRITICAL: 'CRITICAL',
  NONE: 'NONE',
});

/**
 * Log level priorities (lower number = higher priority, will always be logged)
 * @constant {Object}
 */
export const LOG_LEVEL_PRIORITY = Object.freeze({
  [LOG_LEVEL.TRACE]: 50,
  [LOG_LEVEL.DEBUG]: 40,
  [LOG_LEVEL.INFO]: 30,
  [LOG_LEVEL.WARN]: 20,
  [LOG_LEVEL.ERROR]: 10,
  [LOG_LEVEL.CRITICAL]: 0,
  [LOG_LEVEL.NONE]: -10,
});

/**
 * Sensitive fields that should be redacted in logs
 * Includes PII, PCI, and authentication fields
 * @constant {string[]}
 */
export const SENSITIVE_FIELDS = Object.freeze([
  'password',
  'token',
  'refreshToken',
  'secret',
  'apiKey',
  'cardNumber',
  'cvv',
  'ssn',
  'socialSecurity',
  'taxId',
  'creditCard',
  'debitCard',
  'securityCode',
  'accessCode',
  'authorization',
  'bearer',
]);
